import {
  AnswerComponentType,
  type AnswerProblemSolvingWorksheetBody,
  type  SessionRequestProblemSolvingWorksheet,
} from '@/ts/types/dto/session-request-dto';
import type {ProblemSolvingWorksheet} from '@/ts/types/dto/interventions-dto';

/** Returns an empty default answer structure for a problem-solving worksheet */
export function getDefaultProblemSolvingAnswers(): AnswerProblemSolvingWorksheetBody {
  return {
    goal: '',
    problem: '',
    rewards: [''],
    solutions: [{
      activities: [''],
      badThings: '',
      name: '',
      goodThings: '',
    }],
  };
}

/** Converts a problem-solving worksheet's existing answers into the answer body format, or returns defaults if unanswered */
export function propsToValue(worksheet: ProblemSolvingWorksheet): AnswerProblemSolvingWorksheetBody {
  if (worksheet.isAnswered) {
    return {
      goal: worksheet.goal,
      rewards: worksheet.rewards,
      problem: worksheet.problem,
      solutions: worksheet.solutions,
    };
  }
  return getDefaultProblemSolvingAnswers();
}

/** Maps a problem-solving answer into the session request DTO format for submission */
export function valueProblemSolvingToModel(
  worksheet: ProblemSolvingWorksheet,
  answer: AnswerProblemSolvingWorksheetBody,
): SessionRequestProblemSolvingWorksheet {
  return {
    type: AnswerComponentType.PROBLEM_SOLVING_WORKSHEET,
    answerProblemSolvingWorksheet: {
      answer,
      userComponentId: worksheet.userComponentId,
    },
  };
}
